import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const APPLICATIONS_ABILITATIONS_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_APPLICATIONS_ABILITATIONS_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_APPLICATIONS_ABILITATIONS_MGMT}/stepTwo`,
  STEP_THREE: `${ROUTES.ADMIN_APPLICATIONS_ABILITATIONS_MGMT}/stepThree`,
  STEP_FOUR: `${ROUTES.ADMIN_APPLICATIONS_ABILITATIONS_MGMT}/stepFour`,
  STEP_FIVE: `${ROUTES.ADMIN_APPLICATIONS_ABILITATIONS_MGMT}/stepFive`,
};

export const STATE_IDENTIFIER = {
  APPLICATION_LIST_RAW: "applicationListRaw",
  APPLICATIONS_LIST: "applicationsList",
  SELECTED_APPLICATION: "selectedApplication",
  ENTITLEMENT_LIST_RAW: "entitlementsList",
  ENTITLEMENTS_LIST: "entitlementsList",
  SELECTED_ENTITLEMENT: "selectedEntitlement",
  SYSTEM_PROPERTIES: "systemProperties",
  CUSTOM_PROPERTIES: "customProperties",
  GLOBAL_ENTITLEMENTS_LIST: "globalEntitlementsList",
  CHAIN_ENTITLEMENTS_LIST: "chainEntitlementsList",
  CHAIN_ENTITLEMENTS_LIST_ADDED: "chainEntitlementsListAdded",
  CHAIN_ENTITLEMENTS_LIST_DELETED: "chainEntitlementsListDeleted",
  CALL_STATE: "callState",
  BAO: "bao",
  LIST_IDENTIFIER: "list",
  LOADER_IDENTIFIER: "loader",
  STE_ONE: "stepOne",
  STEP_TWO: "stepTwo",
  STEP_THREE: "stepThree",
  STEP_FOUR: "stepFour",
  STEP_FIVE: "stepFive",
};

export enum applicationsAbilitationsManagementValueBooleanType {
  YES = "YESVALUE",
  NO = "NOVALUE",
}

export enum applicationSystemProperties {
  NAME = "name",
  IDENTITY_SYSTEM_ID = "identitySystemId",
  DESCRIPTION = "description",
  BAO_APPROV_CATALOGO = "baoApprovCatalogo",
  COMPANY = "company",
  COMPLIANCE_APPROV_CATALOGO = "complianceApprovCatalogo",
  ORG_APPROV_CATALOGO = "orgApprovCatalogo",
  MONOPROFILO = "monoprofilo",
  RESET_PWD_ALLOWED = "resetPwdAllowed",
  CHANGE_PWD_ALLOWED = "changePwdAllowed",
  MFA_REQUIRED = "mfaRequired",
  SECURITY_QUESTIONS_REQUIRED = "securityQuestionsRequired",
  RISK_APPROV_CATALOGO = "riskApprovCatalogo",
  SEC_GOV_APPROV_ACCOUNT = "secGovApprovAccount",
  SEC_GOV_APPROV_RISK_CATALOGO = "secGovApprovRiskCatalogo",
  SEC_OP_APPROV_ACCOUNT = "secOpApprovAccount",
  SEC_OP_APPROVE_CATALOGO = "secOpApproveCatalogo",
  DB_APPROVE = "dbApprove",
  DB_APPROVE_CATALOG = "dbApproveCatalog",
  DB_APPROVE_ACCOUNT = "dbApproveAccount",
  IDENTITY_APPLICATION_ID = "identityApplicationId",
}

export enum entitlementSystemProperties {
  ADMIN_ROLE_REQUIRED = "adminRoleRequired",
  APPLICATION_NAME = "applicationName",
  BAO_CODE = "baoCode",
  ENTITLEMENT_ID = "entitlementId",
  IDENTITY_SYSTEM_ID = "identitySystemId",
  ENTITLEMENT_NAME = "entitlementName",
  ENTITLEMENT_OVERRIDE_DESCRIPTION = "entitlementOverrideDescription",
  IS_CRITICAL = "isCritical",
  SHOW_ON_FRONTEND = "showOnFrontend",
  DYNAMIC_ROLE = "dynamicRole",
}
